export default __webpack_public_path__ + "static/media/andrewkits.923d797b.jpg";